<template>
  <div class="home">
    <div class="wrapper-content">
      <div class="breadcrumb_box">
        <div class="container-fluid">
          <h2>Wallet</h2>
        </div>
      </div>

      <div class="tab-subcription walletscreen">
        <div class="walletDetails">
          <h3>
            <span class="totalBalance">{{$t('message.Available') }}</span>
            {{currency}}{{totalBalance}}
          </h3>
          <div class="AddMoneyLink">
            <router-link to="/add-money">Add Money to Wallet</router-link>
          </div>
        </div>
        <b-tabs content-class="mt-3">
          <b-tab title="Transactions" active>
            <div class="container">
              <div class id="transactions" v-if="!transactionLists.length">
                <h4 class="text-center mt-5">{{$t('message.TransactionNotFound') }}</h4>
              </div>
              <div class id="transactions" v-else>
                <div
                  class="download-invoice-detail"
                  v-for="(transaction, index) in transactionLists"
                  :key="index"
                >
                  <div class="days-heading">
                    <div>
                      {{transaction.date}}
                      <!-- <div v-on:click="downloadInvoice(transaction.date)">
                        <img class="svg" src="../assets/images/pdf.svg" alt="download" />Download invoice
                      </div>-->
                    </div>
                  </div>

                  <div
                    class="subcription-list panel"
                    v-for="(transactionList, index) in transaction.transList"
                    :key="index"
                    v-on:click="gototransaction(transactionList)"
                  >
                    <div class="creditTypeImg" v-if="transactionList.transaction_amount_type=='Cr'">
                      <img src="../assets/images/new_credit.png" />
                    </div>
                    <div class="creditTypeImg" v-else-if="transactionList.transaction_amount_type=='Dr'">
                      <img src="../assets/images/new_debit.png" />
                    </div>
                    <div class="subsribe-list">
                      <h4>{{transactionList.transaction_type}}</h4>
                      <p>{{newdate(transactionList.time)}}</p>
                      <p>Transaction #{{transactionList.transaction_id}}</p>
                      <p v-if="transactionList.TXNID">TXIND #{{transactionList.TXNID}}</p>
                      Bal: {{currency}}{{transactionList.balance.toFixed(2)}}
                    </div>
                    <div class="active-block">
                      <h2>
                        <span v-if="transactionList.transaction_amount_type=='Cr'">+</span>
                        <span v-else-if="transactionList.transaction_amount_type=='Dr'">-</span>
                        <span>{{currency}}</span>
                        {{transactionList.amount.toFixed(2)}}
                      </h2>
                      <p
                        class="confirmedOrder"
                        style="color:red"
                        v-if="transactionList.status=='failed'"
                      >{{$t('message.Failed') }}</p>
                      <p
                        class="confirmedOrder"
                        style="color:green"
                        v-if="transactionList.status=='success'"
                      >{{$t('message.Success') }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>

          <b-tab title="Debited">
            <div class="container">
              <div class id="transactions" v-if="!transactionLists.length">
                <h4 class="text-center mt-5">{{$t('message.TransactionNotFound') }}</h4>
              </div>
              <div class id="transactions" v-else>
                <div
                  class="download-invoice-detail"
                  v-for="(transaction, index) in transactionLists"
                  :key="index"
                >
                  <div class="days-heading">
                    <div>
                      {{transaction.date}}
                      <!-- <div v-on:click="downloadInvoice(transaction.date)">
                        <img class="svg" src="../assets/images/pdf.svg" alt="download" />Download invoice
                      </div>-->
                    </div>
                  </div>
                  <div v-for="(transactionList, index) in transaction.transList" :key="index">
                    <div
                      class="subcription-list panel"
                      v-if="transactionList.transaction_amount_type=='Dr'"
                    >
                      <div class="creditTypeImg">
                        <img src="../assets/images/new_debit.png" />
                      </div>
                      <div class="subsribe-list">
                        <h4>{{transactionList.transaction_type}}</h4>
                        <p>{{newdate(transactionList.time)}}</p>
                        <p>Transaction #{{transactionList.transaction_id}}</p>
                        <p v-if="transactionList.TXNID">TXIND #{{transactionList.TXNID}}</p>
                        Bal: {{currency}}{{transactionList.balance.toFixed(2)}}
                      </div>
                      <div class="active-block">
                        <h2>
                          <span>{{currency}}</span>
                          - {{transactionList.amount.toFixed(2)}}
                        </h2>
                        <div>
                          <p
                            class="confirmedOrder"
                            style="color:red"
                            v-if="transactionList.status=='failed'"
                          >{{transactionList.status}}</p>

                          <p
                            class="confirmedOrder"
                            style="color:green"
                            v-if="transactionList.status=='success'"
                          >{{transactionList.status}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab title="Credited">
            <div class="container">
              <div class id="transactions" v-if="!transactionLists.length">
                <h4 class="text-center mt-5">{{$t('message.TransactionNotFound') }}</h4>
              </div>
              <div class id="transactions" v-else>
                <div
                  class="download-invoice-detail"
                  v-for="(transaction, index) in transactionLists"
                  :key="index"
                >
                  <div class="days-heading">
                    <div>
                      {{transaction.date}}
                      <!-- <div v-on:click="downloadInvoice(transaction.date)">
                        <img class="svg" src="../assets/images/pdf.svg" alt="download" />Download invoice
                      </div>-->
                    </div>
                  </div>
                  <div v-for="(transactionList, index) in transaction.transList" :key="index">
                    <div
                      class="subcription-list panel"
                      v-if="transactionList.transaction_amount_type==='Cr'"
                    >
                      <div class="creditTypeImg">
                        <img src="../assets/images/new_credit.png" />
                      </div>
                      <div class="subsribe-list">
                        <h4>{{transactionList.transaction_type}}</h4>
                        <p>{{newdate(transactionList.time)}}</p>
                        <p>Transaction #{{transactionList.transaction_id}}</p>
                        <p v-if="transactionList.TXNID">TXIND #{{transactionList.TXNID}}</p>
                        Bal: {{currency}}{{transactionList.balance.toFixed(2)}}
                      </div>
                      <div class="active-block">
                        <h2>
                          <span>{{currency}}</span>
                          + {{transactionList.amount.toFixed(2)}}
                        </h2>
                        <div>
                          <p
                            class="confirmedOrder"
                            style="color:red"
                            v-if="transactionList.status=='failed'"
                          >{{transactionList.status}}</p>

                          <p
                            class="confirmedOrder"
                            style="color:green"
                            v-if="transactionList.status=='success'"
                          >{{transactionList.status}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import credit from "@/assets/images/rupees_credit.png";
import debit from "@/assets/images/rupees_debit.png";
import { getTransactions } from "./../services/api";
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      currency: localStorage.getItem("CurrencySymbol"),
      baseurl: process.env.VUE_APP_API_URL,
      totalBalance: localStorage.getItem("walletBalance"),
      transactionLists: []
    };
  },
  created() {
    this.getTransDetails();
  },
  methods: {
    gototransaction(item) {
      console.log("item", item);

      var transactionInfo = [];
      transactionInfo.push({
        totalAmount: item.amount,
        tranType: item.transaction_type
      });
      localStorage.setItem("transactionInfo", JSON.stringify(transactionInfo));
      this.$router.push({
        name: "transaction-detail",
        query: { id: item.transaction_id }
      });
    },
    downloadInvoice(date) {
      var month = moment(date, "DD-MM-YYYY").format("MM");
      var year = moment(date, "DD-MM-YYYY").format("YYYY");

      var url =
        "https://web.staging02.com/trakop/Transactions/invoice?user_customer_id=" +
        localStorage.getItem("userId") +
        "&year=" +
        year +
        "&month=" +
        month +
        "&vendor_id=" +
        localStorage.getItem("vendorId");
      window.open(url, "_blank");
    },
    newdate(value) {
      if (value) {
        return moment(value).format("DD MMMM, YYYY hh:mm A");
      }
    },
    getTransDetails() {
      if (!localStorage.getItem("userName")) {
        localStorage.clear();
        this.$router.push({ name: "register" });
      } else {
        var requestData = {
          user_id: localStorage.getItem("userId"),
          vendor_id: localStorage.getItem("vendorId")
        };
        getTransactions(requestData)
          .then(result => {
            if (result.data.successCode === 1) {
              var a = result.data.transactions;
              const groups = a.reduce((groups, x) => {
                const date = moment(x.time).format("MMMM-YYYY");

                if (!groups[date]) {
                  groups[date] = [];
                }

                groups[date].push(x);
                return groups;
              }, {});

              this.transactionLists = Object.keys(groups).map(date => {
                return {
                  date,
                  transList: groups[date]
                };
              });
              console.log("^^^", this.transactionLists);
            } else if (
              result.data.successCode === 0 &&
              result.data.messageCode === 1053
            ) {
              localStorage.clear();
              this.$router.replace({ name: "register" });
            }
          })
          .catch(error => {
            return;
          });
      }
    }
  }
};
</script>
